export default __webpack_public_path__ + "static/media/DOM-APR2025.1e129152.png";